//import 'prefixfree';
import 'browsernizr/test/touchevents';
import Modernizr from 'browsernizr';
import 'browsernizr/lib/mq';
import './jquery';
import './easing';
import './texelwire';
//import './slick';
import './simple-dd';
//import './magnific';
//import './select2';
import './ideal-postcodes';
import autosize from './autosize';
import mapStyle from './map-style.json';
import './enllax';
import URLSearchParamsPolyfill from 'url-search-params-polyfill';
import './cycle2';


'use strict';


const URLSearchParamsClass = window.URLSearchParams || URLSearchParamsPolyfill;
window.urlParams = new URLSearchParamsClass(window.location.search);


/**
 * Cache
 */
var $window			= $(window);
var $document 		= $(document);
var $htmlBody 		= $('html, body');
var $body 			= $('body');
var $header 		= $('header');
var $main 			= $('main');
var $mainNavs 		= $('header, div.mobile-menu');


/**
 * Add spans to headings for border decoration
 */
$('div.h1, h1, h2, h3, h4, h5, h6').not('.alt').wrapInner('<span class="decor"></span>');


/**
 * Menu highlight
 */
$mainNavs.find('a[href="' + $.escapeSelector(window.location.pathname) + '"]').addClass('active');
$mainNavs.find('span.drop-down span.child a.active').each(function() {

	$(this).closest('span.drop-down')
	       .children('a')
		   .addClass('active');

});


/**
 * Mobile menu
 */
$('div.mobile-menu nav').prepend($header.find('nav.menu').html());


/**
 * Menu open
 */
$('a.menu-open').on('click', function(e) {
	
	e.preventDefault();
	
	$body.addClass('menu-open');
	
});


/**
 * Menu close
 */
$('div.mobile-menu-base, a.menu-close').on('click', function(e) {
	
	e.preventDefault();
	
	$body.removeClass('menu-open');
	
});


/**
 * Guide tabs (must be before scroll-to)
 */
$('body.guides-and-insights').each(function() {

	var $a = $('main nav.icons a');
	
	$a.on('click', function(e) {
		
		e.preventDefault();
		
		var $this = $(this);
		
		$a.closest('nav.icons')
		  .find('a')
		  .removeClass('active');
		  
		$this.addClass('active');
		
		$main.find('div.categories div.category')
		     .removeClass('active');
			  
		$main.find($this.attr('href'))
			 .addClass('active');
		
	});

});


/**
 * Scroll to
 */
$('a[data-scroll-to]').on('click', function(e) {

	e.preventDefault();
	
	var $this = $(this);

	$htmlBody.animate({

		scrollTop: $($this.attr('href')).offset().top - $header.innerHeight()

	}, 1000, 'easeInOutExpo');

})


/**
 * Go to
 */
$window.on('load', function() {

	var urlParams = new URLSearchParams(window.location.search);
	var goto = urlParams.get('goto');

	if (goto !== null) {
		
		$('a[data-scroll-to][href="#' + $.escapeSelector(goto) + '"]').eq(0)
		                                                              .trigger('click');
		
	}

});


/**
 * Company tabs
 */
$('div.company-tabs').each(function() {

	var $this = $(this);
	
	$this.find('nav a')
	     .on('click', function(e) {
		
		e.preventDefault();
		
		var $a = $(this);
		
		$a.closest('nav')
		  .find('a')
		  .removeClass('alt');
		  
		$a.addClass('alt');
		
		$this.find('div.panel')
		     .removeClass('active')
			 .filter('div.' + $a.data('panel'))
			 .addClass('active');	 
			 
	});
	
	var tab = urlParams.get('tab');

	if (tab !== null) {
		
		$this.find('nav a[data-panel="' + $.escapeSelector(tab) + '"]').trigger('click');
		
	}

});


/**
 * Show next
 */
$('a.show-next').one('click', function(e) {
	
	e.preventDefault();
	
	$(this).addClass('active');
	
});


/**
 * Autosize
 */
autosize($('form textarea'));


/**
 * Select2
 */
const $selects = $('select');

if ($selects.length > 0) {

	await import('./select2');

	$selects.select2({

		width: '100%',
		minimumResultsForSearch: -1

	});

}


/**
 * Slick promos
 */
var $slickElements = $('div.slick-promos, div.slick-promos-new-homes');

if ($slickElements.length > 0) {

	await import('./slick');

	$slickElements.slick({

		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: true,
		prevArrow: '<a class="slick-prev fa fa-angle-left"></a>',
		nextArrow: '<a class="slick-next fa fa-angle-right"></a>',
		responsive: [

			{

				breakpoint: 1170,
				settings: {

					slidesToShow: 2

				}

			},
			{

				breakpoint: 700,
				settings: {

					slidesToShow: 1

				}

			}

		]

	});

}


/**
 * Slick pager
 */
$slickElements = $('div.slick-pager');

if ($slickElements.length > 0) {

	await import('./slick');

	$slickElements.slick({

		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		prevArrow: '<a class="slick-prev fa fa-angle-left"></a>',
		nextArrow: '<a class="slick-next fa fa-angle-right"></a>',
		lazyLoad: 'progressive',
		adaptiveHeight: true
		
	});

}


/**
 * Property links and radios
 */
$('body.property').each(function() {
	
	var $propertyform = $('div#property-enquiry form');

	$('a[data-enquiry-type]').on('click', function(e) {
		
		e.preventDefault();
		
		$propertyform.find('input[name="enquiry-type"][value="' + $(this).data('enquiry-type') + '"]')
		             .prop('checked', true)
					 .trigger('change');
					 
	});
	
	$('div#property-enquiry form input[name="enquiry-type"]').on('change', function() {
		
		var text = $propertyform.find('input[name="enquiry-type"]:checked').val() + ' for ' + $propertyform.find('h2').data('property-name');
		
		$propertyform.find('h2')
		             .text(text);
					 
		$propertyform.find('input[name="property"]')
			 		 .val(text);
		
	});

});


/**
 * Magnific
 */
const $lightboxes = $('a.lightbox.video, a.lightbox.iframe, a.lightbox.inline, div.lightbox.gallery');

if ($lightboxes.length > 0) {
	
	try {

		await import('./magnific');

		// Video Lightbox
		$('a.lightbox.video').magnificPopup({

			disableOn: 900,
			type: 'iframe',
			mainClass: 'lightbox-effect',

		});

		$('a.lightbox.iframe').magnificPopup({
			
			type: 'iframe',
			mainClass: 'mfp-fade'
			
		});

		// Inline Lightbox
		$('a.lightbox.inline').magnificPopup({

			type: 'inline',
			mainClass: 'lightbox-effect',

		});

		// Gallery
		$('div.lightbox.gallery').magnificPopup({

			delegate: 'a',
			type: 'image',
			mainClass: 'lightbox-effect',
			gallery: {

				enabled: true,
				navigateByImgClick: true,
				preload: [0, 1]

			}

		});

	} catch (err) {

		console.error("Magnific Popup failed to load:", err);

	}

}


/**
 * Simple DD
 */
$header.find('span.drop-down')
       .simpleDD({

   noScriptLink:    '> a',
   dropdownElement: 'span.child'

});


/**
 * Alt header
 */
$window.on('scroll resize', function() {

    if ($window.scrollTop() > 100) {

        $header.addClass('alt');

    } else {

        $header.removeClass('alt');

    }

	$header.removeClass('hide');

	$('div.property-search-overlay').removeClass('active');

});


/**
 * Ideal postcodes
 */
var $requestValuation = $('body.request-valuation, body.general-page');

$requestValuation.find('form.pseudo-form').each(function() {
	
	var $form = $(this);
	
	new IdealPostcodes.Autocomplete.Controller({

		api_key: 'ak_kh09fya71OwMw63mFv6tPDS0O99Ja',
		inputField: 'form#request-valuation input[name="search"]',
		outputFields: {

			post_town: 		'form#request-valuation input[name="city"]',
			postal_county: 	'form#request-valuation input[name="county"]',
			postcode: 		'form#request-valuation input[name="postcode"]'

		},
		checkKey: true,
	    onFailedCheck: function () {

	        $form.find('input[name="search"]').closest('div.row')
			                                  .remove();
											  
			$form.addClass('manual');

	    },
		onSearchError: function(response) {

			alert('An address search error occured; please enter your address manually');

			$form.find('input[name="search"]').closest('div.row')
			                                  .remove();
											  
			$form.addClass('manual');

		},
		onAddressRetrieved: function(address) {

			var street = address.line_1;

			street += address.line_2 !== '' ? ', ' + address.line_2 : '';
			street += address.line_3 !== '' ? ', ' + address.line_3 : '';

			$form.find('input[name="street"]').val(street);

			$form.find('input[name="search"]').val('');
			
			$form.addClass('manual');
			
			// Remove manual link
			$form.find('a.manual')
			     .closest('div.row')
				 .remove();

		}

	});

});


/**
 * Request valuation manual link
 */
$requestValuation.find('form a.manual')
                 .on('click', function(e) {
					 
	e.preventDefault();
	
	var $this = $(this);
	
	$this.closest('form')
	     .addClass('manual');
		 
	$this.closest('div.row')
	     .remove();				 
					 
});


/**
 * Testimonials option
 */
$('div.testimonials.home div.options a').on('click', function(e) {
	
	e.preventDefault();
	
	var $this	= $(this);
	
	var $panels = $this.closest('div.testimonials').find('div.quotes div.panel');
	var $links 	= $this.closest('div.options').find('a');
	
	$panels.removeClass('active');
	$links.removeClass('active');
	
	$panels.eq($this.index())
	      .addClass('active');
		  
	$this.addClass('active');
	
}).eq(0)
  .trigger('click');  


/**
 * Locrating
 */
$('div.locrating').each(function() {

	try {

		setLocratingIFrameProperties($(this).data('config'));

	} catch (err) {

		console.log('Locrating error:');
		console.log(err);

	};

});


/**
 * Map
 */
$('div.map').each(function() {
	
	var $map = $(this);
	
	var coordinates = $map.data('coordinates');
	
	var location = new google.maps.LatLng(coordinates[0].latitude, coordinates[0].longitude);
	
	var markers = [];

	var map = new google.maps.Map($map[0], {

		center: location,
		zoom: 12,
		scrollwheel: false,
		styles: mapStyle,
		zoomControl: true

	});
	
	for (var counter = 0; counter < coordinates.length; counter ++) {
		
		location = new google.maps.LatLng(coordinates[counter].latitude, coordinates[counter].longitude);
		
		var marker = new google.maps.Marker({

			map: map,
			position: location,
			icon: {

				url: '/assets/img/gui/marker.png',
				scaledSize: new google.maps.Size(50, 50)

			},
			url: coordinates[counter].url

		});
		
		markers.push(marker);
		
	}
	
	// Add click handlers
	for (var counter = 0; counter < markers.length; counter ++) {

		google.maps.event.addListener(markers[counter], 'click', function() {

			window.location.href = this.url;

		});
		
	}
	
	// Fit bounds
	var bounds = new google.maps.LatLngBounds();

    for (var i = 0; i < markers.length; i ++) {
		
        if (markers[i].getVisible()) {
			
            bounds.extend( markers[i].getPosition());
			
        }
		
    }

    map.fitBounds(bounds);

});


/**
 * Window load events
 */
$window.on('load', function() {
	
	// Image deferring
	$('img[data-src]').each(function() {
	
		var $img = $(this);
		
		$img.attr('src', $img.data('src'));
	
	});
	
	// Background images
	$('[data-bg]').each(function() {
	
		var $el = $(this);
		
		$el.css('background-image', 'url(' + $el.data('bg') + ')');
	
	});
	
	// Parallax
	$window.enllax();

});


/**
 * More article items
 */
$('body.guides-and-insights a.more-items').on('click', function(e) {
	
	e.preventDefault();
	
	var $this = $(this);
	
	var numToShow = parseInt($this.closest('div.category').data('num-to-show'));
						 
	var $articles = $this.closest('div.category').find('div.article');
	
	var unhidden = 0;
	
	// Make the next group visible
	$articles.each(function() {
	
		var $article = $(this);
		
		if ($article.is(':visible') === false) {
			
			$article.removeClass('inactive');
			$article.find('img').attr('src', $article.find('img').data('article-src'));
			
			unhidden ++;
			
			// Only do numToShow at a time
			if (unhidden == numToShow) {
				
				return false;
				
			}
			
		}
	
	});
	
	// Decide whether to hide the button
	var hasHidden = false;
	
	$articles.each(function() {
		
		var $article = $(this);
		
		if ($article.is(':visible') === false) {
			
			hasHidden = true;
			
			return false;
			
		}
		
	});
	
	if (hasHidden === false) {
		
		$this.remove();
		
	}
	
});


/**
 * Sticky messages
 */
var $stickyMessagesA = $('div.sticky.message a');

var timeout = setTimeout(function() {

	$stickyMessagesA.trigger('click');

}, 5000);

$stickyMessagesA.on('click', function(e) {
	
	e.preventDefault();
	
	$(this).closest('div.message').slideUp();
	
	clearTimeout(timeout);
	
});


/**
 * Truncate text with gradient and button
 */
$('div[data-truncate]').each(function() {

	var $div = $(this);
	
	if ($div.innerHeight() > 250) {
		
		$div.addClass('truncated')
		    .append('<div class="truncated-end ' + $div.data('truncate').escapeHTML() + '"></div><a class="button remove-truncation" href="#">Read more</a>');
		
	}

}).on('click', 'a.button.remove-truncation', function(e) {
	
	e.preventDefault();
	
	var $div = $(this).closest('div[data-truncate]');
	
	$div.removeClass('truncated')
	    .find('div.truncated-end, a.remove-truncation')
		.fadeOut();;
	
});;



/**
 * Make external links open in new window
 */
$('div.overlay a[href^="http://"], div.overlay a[href^="https://"]').attr('target','_blank');


/**
 * Bio link
 */
$('a.view-bio').on('click', function(e) {
	
	e.preventDefault();
	
	var $this = $(this);
	
	$this.toggleClass('active');
	
	$this.closest('div.member')
	     .find('div.bio')
		 .toggleClass('active');
	
});


/**
 * Range change
 */
$('input[type="range"]').on('change', function() {

	var $this = $(this);

	var val = $this.val();

	if (val === 0) {

		val = 'Any';

	}

	$this.closest('div.search-option')
	     .find('div.value')
		 .text(val)

	var field = $this.data('field');

	$('form.property-search').find('input[name="' + field + '"]')
	                         .val(val)
							 .end()
							 .find('a.property-search-overlay-trigger.' + field + ' span.value')
							 .text(val);

});


/**
 * Property options click
 */
$('div.property-search-overlay div.options a.option').on('click', function(e) {

	e.preventDefault();

	var $this = $(this);

	$this.siblings().removeClass('active');

	$this.addClass('active');

	var val = $this.data('value');

	if (val === 0) {

		val = 'Any';

	}

	$this.closest('div.search-option')
	     .find('div.value')
		 .text(val);

	var field = $this.data('field');
	var key  = $this.data('key');

	$('form.property-search').find('input[name="' + field + '"]')
	                         .val(key)
							 .end()
							 .find('a.property-search-overlay-trigger.' + field + ' span.value')
							 .text(val);

});


/**
 * Property close link
 */
$('div.property-search-overlay a.close').on('click', function(e) {

	e.preventDefault();

	$(this).closest('div.property-search-overlay')
	       .removeClass('active');

	$header.removeClass('hide');

});


/**
 * Property search overlay triggers
 */
$('a.property-search-overlay-trigger').on('click', function(e) {

	e.preventDefault();

	var $this = $(this);

	var panel = $this.data('panel');

	var type = $this.data('type');

	var $overlay = $('div.property-search-overlay');

	var val = $this.find('span.value').text();

	$overlay.find('div.search-option')
	        .removeClass('active')
			.filter('.' + panel)
			.addClass('active');

	$overlay.find('div.label-and-value div.value')
	        .text(val);

	if (type == 'range') {

		if (val == 'Any') {

			val = 0;

		}

		$overlay.find('div.search-option.active input[type="range"]')
		        .val(val);

	} else {

		$overlay.find('div.search-option.active a.option')
		        .removeClass('active')
				.filter('[data-value="' + val + '"]')
				.addClass('active');

	}
	
	$overlay.addClass('active');

	$header.addClass('hide');

});


/**
 * For sale links
 */
$('form.property-search div.for-sale a').on('click', function(e) {

	e.preventDefault();

	var $this = $(this);

	$this.siblings()
	     .removeClass('active');

	$this.addClass('active');

	$this.closest('form')
	     .find('input[name="for-sale"]')
		 .val($this.data('value'));

});


/**
 * New homes video
 */
$('a.show-new-homes-video').on('click', function(e) {

	e.preventDefault();

	$(this).closest('div.banner')
	       .find('div.video-overlay')
		   .addClass('active');

});

$('a.show-new-homes-video').closest('div.banner')
	   .find('div.video-overlay a.close')
	   .on('click', function(e) {

	e.preventDefault();

	$(this).closest('div.video-overlay')
		   .removeClass('active');
	
 });


/**
 * Polygon map
 */
$('div.polygon-map').each(function() {

	var $map = $(this);

	var map;
	var mapMarkers = [];
	var drawingManager;
	var polygon;
	var drawingMode = null;
	var $properties = $main.find('div.property');

	function initPolygonMap() {

		map = new google.maps.Map($map[0], {

			styles: mapStyle,
			zoom: 4,
			center: {
				
				lat: 53.8008, 
				lng: 1.5491 // Leeds
			
			} 

		});

		// Define the locations for the markers
		var locations = $map.data('locations');

		// Create markers and store them in the mapMarkers array
		locations.forEach(function(location) {

			var mapMarker = new google.maps.Marker({

				position: {
					
					lat: parseFloat(location.latitude), 
					lng: parseFloat(location.longitude)
				
				},
				map: map,
				id: location.id,
				icon: {

					url: '/assets/img/gui/marker.png',
					scaledSize: new google.maps.Size(50, 50)

				}
			
			});
		
			mapMarkers.push(mapMarker);
		
		});

		// Add click handlers
		for (var counter = 0; counter < mapMarkers.length; counter ++) {

			google.maps.event.addListener(mapMarkers[counter], 'click', function() {

				$htmlBody.animate({

					scrollTop: $('main div.property[data-id="' + this.id + '"]').offset().top - $header.innerHeight()

				}, 1000, 'easeInOutExpo');

			});
			
		}
		
		// Fit bounds
		var bounds = new google.maps.LatLngBounds();

	    for (var i = 0; i < mapMarkers.length; i ++) {
			
	        if (mapMarkers[i].getVisible()) {
				
	            bounds.extend(mapMarkers[i].getPosition());
				
	        }
			
	    }

	    map.fitBounds(bounds);

		// Initialize the drawing manager
		drawingManager = new google.maps.drawing.DrawingManager({

			drawingMode: google.maps.drawing.OverlayType.POLYGON,
			drawingControl: false, // Use custom links instead
			drawingControlOptions: {

				position: google.maps.ControlPosition.TOP_CENTER,
				drawingModes: ['polygon']

			},
			polygonOptions: {

				clickable: false,
				editable: false,
				draggable: false

			}

		});

		drawingManager.setMap(map);

		drawingManager.setDrawingMode(drawingMode);

		// Add a listener for when the polygon is completed
		google.maps.event.addListener(drawingManager, 'polygoncomplete', function(event) {

			$properties.addClass('inactive');

			if (polygon) {

				polygon.setMap(null); // Remove the previous polygon

			}

			polygon = event; // Store the new polygon

			var numFound = 0;

			mapMarkers.forEach(function(mapMarker) {

				if (google.maps.geometry.poly.containsLocation(mapMarker.getPosition(), polygon)) {

					$properties.filter('[data-id="' + mapMarker.id + '"]')
					           .removeClass('inactive');

					numFound ++;

				}

			});

			// Sort items based on whether they have the 'highlight' class
			$properties.sort(function(a, b) {

			    var hasClassA = $(a).hasClass('inactive');
			    var hasClassB = $(b).hasClass('inactive');

			    // Sort so that items with the class come first
			    return (hasClassA === hasClassB) ? 0 : (hasClassA ? -1 : 1);

			});

			// Append sorted items back to the container
			$.each($properties, function(index, item) {

			    $(item).parent().prepend(item);

			});

			// Stop drawing
			$map.closest('div.polygon-map-parent')
			    .find('a.polygon-map-draw')
				.trigger('click');

			$htmlBody.animate({

				scrollTop: $('#polygon-map-end').offset().top - $header.innerHeight()

			}, 1000, 'easeInOutExpo');

		});

		// Custom button event listeners
		$map.closest('div.polygon-map-parent')
		    .find('a.polygon-map-draw')
			.on('click', function (e) {
			
			e.preventDefault();

			var $a = $(this);

			if (drawingMode === null) {

				drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);

				drawingMode = 'polygon';

				$a.find('span.text')
				  .text('Stop drawing');

			} else {

				drawingMode = null;

				drawingManager.setDrawingMode(null);
				
				$a.find('span.text')
				  .text('Draw a search');

			}

			
		});

		$map.closest('div.polygon-map-parent')
		    .find('a.polygon-map-clear')
			.on('click', function (e) {
			
			e.preventDefault();

			$properties.addClass('inactive');

			if (polygon) {

				polygon.setMap(null); // Remove the polygon from the map
				polygon = null; // Clear the reference

			}
			
		});

	}

	// Initialize the map when the window loads
	window.onload = initPolygonMap;

});

$('main div.polygon-map-parent a.button.nav').on('click', function(e) {

	e.preventDefault();

	var $this 			= $(this);
	var $properties 	= $main.find('div.property');
	var $searchSummary 	= $main.find('div.search-summary');

	$this.closest('div.polygon-map-parent')
	     .find('a.button')
		 .removeClass('active');

	$this.addClass('active');

	if ($this.data('view') == 'gallery') {

		$this.closest('div.polygon-map-parent')
			     .removeClass('active');

		$properties.removeClass('inactive');

		$searchSummary.show();

	} else {

		$this.closest('div.polygon-map-parent')
			     .addClass('active');

		$properties.addClass('inactive');

		$searchSummary.hide();

	}

});


/**
 * New Homes read more
 */
$('body.new-homes').each(function() {

	$main.find('div.read-more a')
	     .on('click', function(e) {

		e.preventDefault();

		var $this = $(this);

		$main.find('div.properties-2')
		     .show();

		$this.closest('div.read-more')
		     .remove();

	});

});


/**
 * Google Places testimonials
 */
$.get('/json-testimonials', function(data) {

	var $template = $('template.testimonial');

	$main.find('div.google-testimonials')
	     .each(function() {

		var $this 		= $(this);
		var maxToShow	= $this.data('max-to-show');
		maxToShow 		= data.length < maxToShow ? data.length : maxToShow;

		for (var counter = 0; counter < maxToShow; counter ++) {

			$this.append($template.html());

			var $el = $this.find('div.testimonial')
			               .last();
						   
			$el.find('div.quote p')
			   .text(data[counter].text);

			$el.find('div.quote p')
			   .html($el.find('div.quote p').html().replace(/(\r\n|\n|\r)/g, '<br />'));

			$el.find('div.name')
			   .text(data[counter].author_name);

		}

	});

}).fail(function() {

    console.error('Error fetching Google Places data');

});


$window.trigger('scroll');
$window.trigger('resize');

